import { updateGramCounterStyles, updateToggleStyles } from "./gram-counter.js";

(($) => {
  $(() => {
    const $header = $('.header');
    const $gramCounter = $('.gram-counter');

    if ($header.length) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio < 1) {
            $header.addClass('header--sticky');

            if ($gramCounter.length) {
              $gramCounter.addClass('shadow-sm');
            } else {
              $header.addClass('shadow-sm');
            }
          } else {
            $header.removeClass('header--sticky');

            if ($gramCounter.length) {
              $gramCounter.removeClass('shadow-sm');
            } else {
              $header.removeClass('shadow-sm');
            }
          }
        },
        {
          rootMargin: '-1px 0px 0px 0px', // Slight negative margin to trigger near top
          threshold: [0, 1], // Trigger when entering and leaving the viewport
        }
      );

      observer.observe($header.get(0));
    }
  });
})(jQuery);
